<mat-select (selectionChange)="updateValue($event)" [(ngModel)]="_value">
  @for (item of items; track item) {
    <mat-option [value]="item.id">
      <ng-container
        [ngTemplateOutlet]="getTemplate()"
        [ngTemplateOutletContext]="{ $implicit: item }"
      >
      </ng-container>
    </mat-option>
  }
</mat-select>

<ng-template #defaultOptionLabelTemplate let-item>{{ item.label }}</ng-template>
